import { useSelector } from "react-redux";
import getLogsFromAlcoholData, { Log } from "src/lib/getLogsFromAlcoholData";
import { Separator } from "../ui/separator";
import DrinkLogLine from "./DrinkLogLine";
import EventLogLine from "./EventLogLine";
import PhotoLogLine from "./PhotoLogLine";
import SaveSessionDrawer from "../SaveSessionDrawer";
import { Button } from "../ui/button";
import { ArchiveIcon } from "@radix-ui/react-icons";

export default function DrinkLog({
  alcoholData,
  allowDeletion = false,
  ownData = false,
  style = undefined,
  allowSavingSession = false,
}) {
  const logs = getLogsFromAlcoholData(alcoholData);

  return (
    <div
      className="flex flex-col gap-2"
      style={{
        ...(style ?? {}),
      }}
    >
      {logs.length === 0 && (
        <div style={{ textAlign: "center" }}>Žádné záznamy</div>
      )}
      {logs
        .map((log: Log) => {
          if (log.type === "drink")
            return (
              <DrinkLogLine
                drunkDrink={log.data}
                key={log.data.id}
                allowDeletion={allowDeletion}
                ownData={ownData}
                alcoholData={alcoholData}
              />
            );

          if (log.type === "event")
            return (
              <EventLogLine
                event={log.data}
                key={log.data.id}
                allowDeletion={allowDeletion}
                ownData={ownData}
                alcoholData={alcoholData}
              />
            );

          if (log.type === "photo")
            return (
              <PhotoLogLine
                photo={log.data}
                key={log.data.id}
                allowDeletion={allowDeletion}
                ownData={ownData}
                alcoholData={alcoholData}
              />
            );

          return null;
        })
        .reduce((prev, curr, index) => {
          if (index !== 0) {
            const currentDateString = new Date(
              logs[index].data.date
            ).toDateString();
            const previousDateString = new Date(
              logs[index - 1]?.data.date
            ).toDateString();
            if (currentDateString !== previousDateString) {
              return (
                <>
                  {prev}
                  <div
                    className={`relative w-full flex flex-col justify-center ${
                      allowSavingSession ? "pb-2" : ""
                    }`}
                  >
                    <div className="flex">
                      <div className="flex justify-center flex-1 items-center">
                        <div className="bg-background z-10 px-2 font-bold">
                          {new Date(logs[index].data.date).toLocaleDateString(
                            "cs"
                          )}
                        </div>
                      </div>
                      {allowSavingSession && (
                        <SaveSessionDrawer
                          defaultDates={[
                            new Date(logs[index].data.date).toLocaleDateString(
                              "cs"
                            ),
                          ]}
                        >
                          <Button className={`flex justify-center gap-2 z-10`}>
                            <ArchiveIcon />
                            Uložit seanci
                          </Button>
                        </SaveSessionDrawer>
                      )}
                    </div>
                    <Separator className="absolute" />
                  </div>
                  {curr}
                </>
              );
            }
          }

          return (
            <>
              {prev}
              {index !== 0 && <Separator />}
              {curr}
            </>
          );
        }, <></>)}
    </div>
  );
}

export function CurrentDrinkLog() {
  const alcohol = useSelector((state: any) => state.alcohol);

  return (
    <DrinkLog
      alcoholData={alcohol}
      allowDeletion={true}
      ownData
      allowSavingSession={true}
    />
  );
}
